import * as React from 'react';

const BarcodeIcon = ({
    size = 24,
    color = '#333333',
    role = 'default',
    name = 'icon',
    style = {},
    iconStr = '',
    ...Rest
}) => {

    const styles = {
        cursor: 'pointer',
        ...style,
    }

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={styles}
            {...Rest}
        >
            <g clipPath="url(#clip0_6728_371)">
                <path d="M21.375 4.5H22.125V5.25H21.375V4.5Z" fill={color} />
                <path
                    d="M23.25 0.375H0.75C0.650544 0.375 0.555161 0.414509 0.484835 0.484835C0.414509 0.555161 0.375 0.650544 0.375 0.75V15.75C0.375 15.8495 0.414509 15.9448 0.484835 16.0152C0.555161 16.0855 0.650544 16.125 0.75 16.125H6.375V16.1186C6.79919 16.9114 7.38584 17.6058 8.09663 18.1565C8.80742 18.7072 9.62637 19.1017 10.5 19.3144V21.375H10.125C10.0255 21.375 9.93016 21.4145 9.85983 21.4848C9.78951 21.5552 9.75 21.6505 9.75 21.75V23.625H10.5V22.125H13.5V23.625H14.25V21.75C14.25 21.6505 14.2105 21.5552 14.1402 21.4848C14.0698 21.4145 13.9745 21.375 13.875 21.375H13.5V19.3144C14.3736 19.1017 15.1926 18.7072 15.9034 18.1565C16.6142 17.6058 17.2008 16.9114 17.625 16.1186V16.125H23.25C23.3495 16.125 23.4448 16.0855 23.5152 16.0152C23.5855 15.9448 23.625 15.8495 23.625 15.75V0.75C23.625 0.650544 23.5855 0.555161 23.5152 0.484835C23.4448 0.414509 23.3495 0.375 23.25 0.375ZM12.75 21.375H11.25V19.452C11.748 19.516 12.252 19.516 12.75 19.452V21.375ZM12 18.75C10.8875 18.75 9.79994 18.4201 8.87492 17.802C7.94989 17.1839 7.22892 16.3054 6.80318 15.2776C6.37743 14.2498 6.26604 13.1188 6.48308 12.0276C6.70012 10.9365 7.23585 9.93419 8.02252 9.14752C8.80919 8.36085 9.81147 7.82512 10.9026 7.60808C11.9938 7.39104 13.1248 7.50243 14.1526 7.92818C15.1804 8.35392 16.0589 9.07489 16.677 9.99992C17.2951 10.9249 17.625 12.0125 17.625 13.125C17.6233 14.6163 17.0301 16.0461 15.9756 17.1006C14.9211 18.1551 13.4913 18.7483 12 18.75ZM22.875 15.375H17.9573C18.4839 13.9986 18.5141 12.4816 18.0428 11.0853C17.5715 9.689 16.6281 8.5007 15.375 7.725V3.375H14.625V7.32225C14.3815 7.20966 14.131 7.11283 13.875 7.03238V3.375H13.125V6.85538C12.7538 6.78712 12.3774 6.75186 12 6.75C11.8733 6.75 11.7499 6.76163 11.625 6.76912V3.375H10.875V6.85538C10.6216 6.89903 10.3712 6.95814 10.125 7.03238V3.375H9.375V7.32225C9.11627 7.43957 8.86571 7.57412 8.625 7.725V3.375H7.875V8.25H7.9005C6.88692 9.09588 6.16298 10.2373 5.8299 11.5148C5.49681 12.7923 5.57123 14.1419 6.04275 15.375H1.125V1.125H22.875V15.375Z"
                    fill={color}
                />
                <path
                    d="M2.625 2.625H3.75V1.875H2.25C2.15054 1.875 2.05516 1.91451 1.98484 1.98484C1.91451 2.05516 1.875 2.15054 1.875 2.25V3.75H2.625V2.625Z"
                    fill={color}
                />
                <path
                    d="M21.375 3.75H22.125V2.25C22.125 2.15054 22.0855 2.05516 22.0152 1.98484C21.9448 1.91451 21.8495 1.875 21.75 1.875H20.25V2.625H21.375V3.75Z"
                    fill={color}
                />
                <path
                    d="M2.25 14.625H3.75V13.875H2.625V12.75H1.875V14.25C1.875 14.3495 1.91451 14.4448 1.98484 14.5152C2.05516 14.5855 2.15054 14.625 2.25 14.625Z"
                    fill={color}
                />
                <path
                    d="M22.125 14.25V12.75H21.375V13.875H20.25V14.625H21.75C21.8495 14.625 21.9448 14.5855 22.0152 14.5152C22.0855 14.4448 22.125 14.3495 22.125 14.25Z"
                    fill={color}
                />
                <path d="M4.125 3.375H4.875V13.125H4.125V3.375Z" fill={color} />
                <path d="M5.625 3.375H6.375V8.25H5.625V3.375Z" fill={color} />
                <path d="M16.875 3.375H17.625V8.25H16.875V3.375Z" fill={color} />
                <path d="M19.125 3.375H19.875V13.125H19.125V3.375Z" fill={color} />
                <path
                    d="M11.9997 8.46484C11.0779 8.46484 10.1768 8.7382 9.4103 9.25034C8.64382 9.76249 8.04643 10.4904 7.69366 11.3421C7.34089 12.1937 7.24859 13.1309 7.42843 14.035C7.60827 14.9391 8.05217 15.7696 8.70401 16.4215C9.35584 17.0733 10.1863 17.5172 11.0905 17.697C11.9946 17.8769 12.9317 17.7846 13.7834 17.4318C14.635 17.079 15.363 16.4816 15.8751 15.7152C16.3873 14.9487 16.6606 14.0476 16.6606 13.1257C16.6591 11.89 16.1676 10.7054 15.2938 9.83163C14.4201 8.95787 13.2354 8.46633 11.9997 8.46484ZM11.9997 17.0366C11.2102 17.0378 10.4388 16.7997 9.7873 16.3536C9.13584 15.9075 8.63491 15.2743 8.35062 14.5377C8.06632 13.8011 8.012 12.9956 8.19484 12.2275C8.37767 11.4594 8.78907 10.7648 9.37474 10.2352V13.1257H10.1247V9.69522C10.3631 9.56479 10.6145 9.45971 10.8747 9.38172V13.1257H11.6247V9.23397C11.7481 9.22197 11.873 9.21484 11.9997 9.21484C12.3809 9.215 12.76 9.27123 13.1247 9.38172V13.1257H13.8747V9.69522C14.1452 9.84496 14.397 10.0262 14.6247 10.2352V13.1257H15.3747V11.1592C15.7227 11.7528 15.9076 12.4277 15.9106 13.1158C15.9137 13.8038 15.7349 14.4804 15.3923 15.077C15.0497 15.6736 14.5554 16.1691 13.9597 16.5133C13.3639 16.8574 12.6878 17.0379 11.9997 17.0366Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_6728_371">
                    <rect width={size} height={size} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default BarcodeIcon;
